import React from 'react'
import Workspace from "components/Workspace";
import EmailListSection from "./components/EmailListSection";
import Tr from "translations/Translations";
import Section from "../part2/components/Section";

function EmailListPanel(
    {
        match
    }) {

    const demandId = match.params.id;

    return (<Section
        title={Tr('email_list')}
    ><Workspace render={<EmailListSection demandId={demandId}/>}/>
    </Section>)
}


export default EmailListPanel;